import { CardRoot } from './card.root';
import { CardCard } from './card/card.card';
import { CardTitle } from './title/card.title';
import { CardContent } from './content/card.content';
import { CardActions } from './actions/card.actions';
import { CardActionable } from './actionable/card.actionable';

// Compound component pattern
export const Card = {
  Root: CardRoot,
  Card: CardCard,
  Title: CardTitle,
  Content: CardContent,
  Actions: CardActions,
  Actionable: CardActionable,
};
